export * from 'server/models/Notification';


// WEBPACK FOOTER //
// ./data/models/Notification.ts